// // import React from 'react';
// // import { AppBar, Toolbar, Typography, IconButton, Avatar, Box } from '@mui/material';
// // import MenuIcon from '@mui/icons-material/Menu';
// // import { styled } from '@mui/material/styles';
// // const Offset = styled('div')(({ theme }) => theme.mixins.toolbar);
// // function NavigationBar({ handleDrawerToggle }) {
// //   return (
// //     <>
// //       <AppBar position="fixed" color="primary" elevation={1}>
// //         <Toolbar>
// //           <IconButton edge="start" color="inherit" onClick={handleDrawerToggle} sx={{ mr: 2 }}>
// //             <MenuIcon />
// //           </IconButton>
// //           {/* Centered LIVA text */}
// //           <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
// //             <Typography
// //               variant="h2"
// //               sx={{
// //                 fontWeight: 'bold',
// //                 fontSize: '4rem',
// //                 color: 'transparent', // Ensure base text is transparent
// //                 position: 'relative',
// //                 WebkitTextFillColor: 'transparent',
// //                 WebkitBackgroundClip: 'text',
// //                 backgroundImage: 'linear-gradient(to right, #001f33, #0066cc, #f f0066, #ff6f00, #ff6f00, #00ffff, #99ff33)', // ICICI-inspired gradient
// //                 backgroundSize: '200% 100%', // Make the gradient larger for smooth scrolling
// //                 animation: 'gradientSlide 3s infinite ease-in-out', // Animation for gradient movement
// //               }}
// //             >
// //               LIVA
// //               <style>
// //                 {`
// //                   @keyframes gradientSlide {
// //                     0% { background-position: 0% 50%; }
// //                     25% { background-position: 25% 50%; }
// //                     50% { background-position: 50% 50%; }
// //                     60% { background-position: 60% 50%; /* Focus on neon orange */ }
// //                     75% { background-position: 75% 50%; }
// //                     100% { background-position: 0% 50%; }
// //                   }                  
// //                 `}
// //               </style>
// //             </Typography>
// //           </Box>
// //           <Avatar src="/path/to/agent-profile.png" alt="Agent" />
// //         </Toolbar>
// //       </AppBar>
// //       <Offset />
// //     </>
// //   );
// // }
// // export default NavigationBar;


// import React from 'react';
// import { AppBar, Toolbar, Typography, IconButton, Avatar, Box } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import { styled } from '@mui/material/styles';
// const Offset = styled('div')(({ theme }) => theme.mixins.toolbar);
// function NavigationBar({ handleDrawerToggle }) {
//   return (
//     <>
//       <AppBar position="fixed" color="primary" elevation={1}>
//         <Toolbar>
//           <IconButton edge="start" color="inherit" onClick={handleDrawerToggle} sx={{ mr: 2 }}>
//             <MenuIcon />
//           </IconButton>
//           {/* Centered LIVA text */}
//           <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 'bold',
//                 fontSize: '4rem',
//                 // color: 'transparent', // Ensure base text is transparent
//                 color: '#00529B',
//                 position: 'relative',
//                 // WebkitTextFillColor: 'transparent',
//                 // WebkitBackgroundClip: 'text',
//                 // backgroundImage: 'linear-gradient(to right, #001f33, #0066cc, #ff0066, #ff6f00, #ff6f00, #00ffff, #99ff33)', // ICICI-inspired gradient
//                 // backgroundSize: '200% 100%', // Make the gradient larger for smooth scrolling
//                 // animation: 'gradientSlide 3s infinite ease-in-out', // Animation for gradient movement
//               }}
//             >
//               LIVA
//               <style>
//                 {`
//                   @keyframes gradientSlide {
//                     0% { background-position: 0% 50%; }
//                     25% { background-position: 25% 50%; }
//                     50% { background-position: 50% 50%; }
//                     60% { background-position: 60% 50%; /* Focus on neon orange */ }
//                     75% { background-position: 75% 50%; }
//                     100% { background-position: 0% 50%; }
//                   }                  
//                 `}
//               </style>
//             </Typography>
//           </Box>
//           <Avatar src="/path/to/agent-profile.png" alt="Agent" />
//         </Toolbar>
//       </AppBar>
//       <Offset />
//     </>
//   );
// }
// export default NavigationBar;


// NavigationBar.js
import React from 'react';
import {
  AppBar, Toolbar, Typography, IconButton, Avatar, Box
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { styled } from '@mui/material/styles';
import Logo from '../pages/images/Livalogo.png';
import AgentPic from '../pages/images/logo_liv.jpg'; 
const Offset = styled('div')(({ theme }) => theme.mixins.toolbar);
function NavigationBar({ handleDrawerToggle }) {
  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          background:
            // 'linear-gradient(90deg,#ff7528 0%,#ff5400 25%,#c00026 60%,#89001b 100%)'
            'linear-gradient(90deg,#89001b 0%,#c00026 25%,#ff5400 60%,#ff7528 100%)'
        }}
      >
        <Toolbar sx={{ px: { xs: 1, md: 3 } }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          {/* centred brand – swaps to logo on mobile */}
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 900,
                letterSpacing: '.05em',
                background:
                  'linear-gradient(90deg,#fff 0%,#ffe2e2 30%,#fff 60%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                display: { xs: 'none', md: 'inline-block' }
              }}
            >
              LIVA
            </Typography>
            <Box
              component="img"
              src={Logo}
              alt="LIVA"
              sx={{ height: 32, display: { xs: 'block', md: 'none' } }}
              // sx={{ height: 64 }}
            />
          </Box>
          <Avatar src={AgentPic} alt="Agent" />
        </Toolbar>
      </AppBar>
      <Offset />
    </>
  );
}
export default NavigationBar;